/**
 * Turn an axios/FastAPI error into a plain STRING safe to hand to toast()/JSX.
 *
 * FastAPI's `detail` is a string for simple errors but an OBJECT for the richer
 * ones (402 usage limits send {message, usage, upgrade_url}, 422 sends an array
 * of validation objects). Passing that object straight to toast.error() renders
 * an object as a React child -> React error #31 -> blank white screen.
 */
export const getApiErrorMessage = (error, fallback = 'Something went wrong. Please try again.') => {
  const detail = error?.response?.data?.detail;

  if (typeof detail === 'string' && detail.trim()) return detail;

  if (Array.isArray(detail)) {
    const msg = detail.map((d) => d?.msg || d?.message).filter(Boolean).join('; ');
    if (msg) return msg;
  }

  if (detail && typeof detail === 'object') {
    const msg = detail.message || detail.reason || detail.error;
    if (typeof msg === 'string' && msg.trim()) return msg;
  }

  if (typeof error?.response?.data?.message === 'string') return error.response.data.message;

  return fallback;
};

export default getApiErrorMessage;
